import { todayISO } from './date'

const EPSILON = 0.01

export const PAYOUT_STATUSES = {
  expected: { key: 'expected', label: 'Ожидается', tone: 'brand' },
  paid: { key: 'paid', label: 'Выплачено полностью', tone: 'success' },
  partial: { key: 'partial', label: 'Выплачено частично', tone: 'warning' },
  overpaid: { key: 'overpaid', label: 'Переплата', tone: 'info' },
  underpaid: { key: 'underpaid', label: 'Недоплата', tone: 'danger' },
  overdue: { key: 'overdue', label: 'Просрочено', tone: 'danger' }
}

export function resolvePayoutStatus({ expectedAmount = 0, actualAmount = 0, payoutDate = '', hasPayout = false, now = todayISO() }) {
  const expected = Number(expectedAmount || 0)
  const actual = Number(actualAmount || 0)
  const difference = actual - expected
  const pastDue = Boolean(payoutDate && payoutDate < now)

  if (!hasPayout || actual <= EPSILON) return PAYOUT_STATUSES[pastDue ? 'overdue' : 'expected']
  if (Math.abs(difference) <= EPSILON) return PAYOUT_STATUSES.paid
  if (difference > EPSILON) return PAYOUT_STATUSES.overpaid
  return PAYOUT_STATUSES[pastDue ? 'underpaid' : 'partial']
}
